/* src/app/components/doc-viewer-new/doc-viewer-content/doc-viewer-content.component.scss */
:host {
  height: 100%;
}
/*# sourceMappingURL=doc-viewer-content.component.css.map */
